<template>
  <div class="jiaoxuezhenrong">
    <!-- 分享所带图片 -->
    <img
      style="width: 0px; height: 0px; position: absolute; z-index: -1"
      src="../../assets/images/dongguologo.jpg"
    />
    <div class="Oulist" v-for="(item, index) in arrLIst" :key="index">
      <div
        class="information edit"
        v-html="item.HtmlBody ? item.HtmlBody : ''"
      ></div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  metaInfo() {
    return {
      title: "教学阵容-影像制作学-韩国东国大学中文官网",
      meta: [
        {
          hid: "keywords",
          name: "keywords",
          content: "东国大学教学阵容,东国大学影像研究生院,东国大学师资介绍",
        },
        {
          hid: "description",
          name: "description",
          content: "",
        },
      ],
    };
  },
  name: "jiaoxue",
  data() {
    return {
      arrLIst: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$axios
        .post("/trip/TokenPass/GetPublishMenuContent", {
          WebsiteMenuId: 597,
          index: 1,
          size: 1,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.arrLIst = res.data.Data.list;
       
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
    },
  },
  activated() {
    this.$emit("handleTKD", "影像制作学");
  },
};
</script>

<style lang="scss" scoped>
.jiaoxuezhenrong {
  margin-top: 134px;
  padding: 0.3rem 40px 61px 30px;
}
.Oulist {
  width: 100%;


  /deep/.information {
    // margin: 0 auto;
    width: 100%;
    min-height: 10rem;

    img,
    video {
      max-width: 100%;
    }
  }
}
</style>
